<template>
  <div class="quiz-layout">
    <div class="quiz-layout__content">
      <slot name="content"></slot>
    </div>
    <div class="quiz-layout__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuizLayout"
};
</script>

<style lang="scss" scoped>
.quiz-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  &__title {
    flex-grow: 0;
  }

  &__content {
    animation: enterContent 1.2s forwards ease;
    display: block;
    flex-grow: 1;
    margin-bottom: 50px;
    padding: spacer("m") 0;

    @include if-tablet {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 80px;
      padding: spacer("l") 0;
    }

    @keyframes enterContent {
      0% {
        opacity: 0;
        transform: translateY(-50px);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  &__footer {
    animation: enterFooter 0.8s forwards 0.3s ease;
    background: theme-color("gradient-gray");
    border-top: 1px solid theme-color("border-dark");
    bottom: 0;
    height: 50px;
    left: 0;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateY(100%);
    width: 100%;

    @include if-tablet {
      height: 60px;
    }

    @keyframes enterFooter {
      0% {
        transform: translateY(100%);
      }
      100% {
        transform: translateY(0);
      }
    }
  }
}
</style>
